module.exports = __webpack_public_path__ + "common/sidebar/icon-yen-mark-413ea00a0debee580a8afca318f1c59a.svg";